import React, { useEffect, useState } from 'react'

import { SendPinCodePage } from '../SendPinCodePage/SendPinCodePage'
import AccessNavigator, { createNewRouter } from '../AccessNavigator'
import { CheckPinCodePage, SEND_MODES } from '../CheckPinCodePage/CheckPinCodePage'
import { PhoneVerifyConfirmationPage } from '../PhoneVerifyConfirmationPage'
import { PhoneValidationSuccessPage } from '../PhoneValidationSuccessPage'
import CountdownProvider from '../../../util/providers/CountdownProvider'
import { RemovePhoneConfirmationPage } from '../RemovePhoneConfirmationPage/RemovePhoneConfirmationPage'
import { FocusHeader } from '@olxbr/ds-web'

const router = createNewRouter('SendPinCode')

const PhoneValidation = ({
  onClickBounce,
  onSuccess,
  showBounceLink,
  abTests,
  token,
  from,
  modalMode,
  onAccountCompleteData,
}) => {
  const [phone, setPhone] = useState('')
  const [emails, setEmails] = useState([])
  const [pincode, setPincode] = useState('')
  const [showRemovedAdsMessage, setShowRemovedAdsMessage] = useState(false)
  const [context, setContext] = useState(undefined)
  const [sendMode, setSendMode] = useState(SEND_MODES.PHONE)
  const contextsAllowed = ['login', 'signup']

  useEffect(() => {
    getContext(from)
  }, [from])

  const getContext = context => {
    if (contextsAllowed.includes(context)) {
      setContext(context)
    }
  }

  const onSendCodeSuccess = newPhone => {
    setPhone(newPhone)
    router.push('CheckPinCode')
  }

  const onAlreadyHasCodeClick = phone => {
    setPhone(phone)
    router.push('PhoneVerifyConfirmation')
  }

  const goBack = e => {
    if (e) e.preventDefault()
    if (router.canPop()) {
      router.pop()
    } else {
      router.push('SendPinCode')
    }
  }

  const goBackToBeginning = () => router.push('SendPinCode')

  const onPhoneVerifySuccess = newPhone => {
    setPhone(newPhone)
    router.push('CheckPinCode')
  }

  const onCheckPinCodeSuccess = () => {
    if (!modalMode) {
      router.push('PhoneValidationSuccess')
    } else {
      onSuccess()
    }
  }

  const onPhoneOverrideSuccess = () => {
    if (!modalMode) {
      router.push('PhoneValidationSuccess')
    } else {
      onSuccess()
    }
  }

  const onPhoneConflict = (_, emails, pincode) => {
    setEmails(emails)
    setPincode(pincode)
    setShowRemovedAdsMessage(true)
    router.push('RemovePhoneConfirmationPage')
  }

  return (
    <CountdownProvider>
      {!modalMode && <FocusHeader />}
      <AccessNavigator
        router={router}
        routes={[
          {
            route: 'SendPinCode',
            component: () => (
              <SendPinCodePage
                onClickBounce={onClickBounce}
                showBounceLink={showBounceLink}
                onSuccess={onSendCodeSuccess}
                onAlreadyHasCodeClick={onAlreadyHasCodeClick}
                token={token}
                abTests={abTests}
                modalMode={modalMode}
                onChooseSendMode={setSendMode}
              />
            ),
          },
          {
            route: 'CheckPinCode',
            component: () => (
              <CheckPinCodePage
                phone={phone}
                onBackClick={goBack}
                onSuccess={onCheckPinCodeSuccess}
                onPhoneConflict={onPhoneConflict}
                abTests={abTests}
                token={token}
                from={context}
                modalMode={modalMode}
                defaultSendMode={sendMode}
                onAccountCompleteData={onAccountCompleteData}
                isPhoneValidationFlow
              />
            ),
          },
          {
            route: 'PhoneVerifyConfirmation',
            component: () => (
              <PhoneVerifyConfirmationPage
                phone={phone}
                onPhoneVerifyConfirmationSuccess={onPhoneVerifySuccess}
                onBackClick={goBack}
                token={token}
                abTests={abTests}
                modalMode={modalMode}
              />
            ),
          },
          {
            route: 'PhoneValidationSuccess',
            component: () => (
              <PhoneValidationSuccessPage
                showRemovedAdsMessage={showRemovedAdsMessage}
                onSuccess={onSuccess}
              />
            ),
          },
          {
            route: 'RemovePhoneConfirmationPage',
            component: () => (
              <RemovePhoneConfirmationPage
                onSuccess={onPhoneOverrideSuccess}
                onBackClick={goBackToBeginning}
                phone={phone}
                emails={emails}
                pincode={pincode}
                token={token}
                abTests={abTests}
                onAccountCompleteData={onAccountCompleteData}
              />
            ),
          },
        ]}
      />
    </CountdownProvider>
  )
}

export { PhoneValidation }
